module.exports = __webpack_public_path__ + "img/21-Digestion.332c040f.png";